module.exports = __webpack_public_path__ + "img/logo.eded90b1.png";